import EntityBase from '@/data/EntityBase';
import QuickBooksCheck from '@/integrations/modules/qbo/models/check';

export default class QuickBooksState extends EntityBase({
  check: new QuickBooksCheck(),
}) {}
